import React, { useState } from 'react';
import { Select, Input } from 'antd';
import { Param } from '../../cliDataSchema';
import ParamFormItem from './ParamFormItem';
import useSonarPermissionGroups from '../../hooks/query/useSonarPermissionGroups';

type PermissionGroup = {
  name: string;
  namespace: string;
  description?: string;
};

type Props = { param: Param; visibleParams: Param[] };

const TextOption: React.FC<Props> = ({ param, visibleParams }) => {
  const [disabled, setDisabled] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string | undefined>();
  const { data: permissionGroups } = useSonarPermissionGroups();

  const options =
    permissionGroups?.map((group: PermissionGroup) => ({
      label: `${group.name} (${group.namespace})`,
      value: group.namespace,
    })) || [];

  const handleSelectChange = (value: string | undefined) => {
    setSelectedValue(value);
  };

  return (
    <ParamFormItem
      param={param}
      disabled={disabled}
      setDisabled={setDisabled}
      visibleParams={visibleParams}
    >
      {param.multiple && param.type.choices ? (
        <Select
          mode="multiple"
          disabled={disabled}
          allowClear={!param.required}
          showSearch
          filterOption={(input, option) =>
            (option?.label as string)
              ?.toLowerCase()
              .includes(input.toLowerCase())
          }
          options={options}
          placeholder="Select options"
        />
      ) : param.multiple ? (
        <Select
          mode="tags"
          disabled={disabled}
          allowClear={!param.required}
          open={false}
          tokenSeparators={[',']}
          placeholder="Type a value and press Enter to add"
        />
      ) : param.type.choices ? (
        <Select
          value={selectedValue}
          onChange={handleSelectChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            (option?.label as string)
              ?.toLowerCase()
              .includes(input.toLowerCase())
          }
          options={options}
          placeholder="Select an option"
        />
      ) : param.osep_generator_ui_is_secret ? (
        <Input.Password
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
        />
      ) : (
        <Input
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
        />
      )}
    </ParamFormItem>
  );
};

export default TextOption;
